import { ALL_GROUPS } from '../../constants';
import { ElevatorStatus } from '../../models/StatusModel';
import { ErisStatusSearchingParameters } from '../../store/ErisInformationStore';

type ErisParamKey =
  | 'searchParams'
  | 'groupName'
  | 'userId'
  | 'buildingName'
  | 'operationStatus'
  | 'pageNumber'
  | 'pageSize';

interface FlatParams {
  groupName?: string | null;
  userId?: string | null;
  buildingName?: string;
  operationStatus?: ElevatorStatus;
}

export function partialErisStatusSearchingParameters(
  params: ErisStatusSearchingParameters,
  include: ErisParamKey[] = [
    'searchParams',
    'groupName',
    'userId',
    'buildingName',
    'operationStatus',
    'pageNumber',
    'pageSize',
  ]
): Partial<ErisStatusSearchingParameters> & FlatParams {
  const out: Partial<ErisStatusSearchingParameters> & FlatParams = {};

  include.forEach((key) => {
    switch (key) {
      case 'searchParams':
        out.searchParams = { ...params.searchParams };
        if (out.searchParams?.groupName === ALL_GROUPS) {
          delete out.searchParams?.groupName;
        }

        if (out.searchParams?.buildingName === '') {
          delete out.searchParams?.buildingName;
        }

        if (out.searchParams.operationStatus === undefined) {
          delete out.searchParams.operationStatus;
        }

        if (Object.keys(out.searchParams).length === 0) {
          delete out.searchParams;
        }

        break;
      case 'groupName':
        if (params.searchParams.groupName === ALL_GROUPS) {
          break;
        }
        if (params.searchParams.groupName !== undefined) {
          out.groupName = params.searchParams.groupName;
        }

        break;
      case 'userId':
        if (params.searchParams.userId !== undefined) {
          out.userId = params.searchParams.userId;
        }

        break;
      case 'buildingName':
        if (params.searchParams.buildingName && params.searchParams?.buildingName.trim() !== '') {
          out.buildingName = params.searchParams.buildingName.trim();
        }
        break;
      case 'operationStatus':
        if (params.searchParams.operationStatus !== undefined) {
          out.operationStatus = params.searchParams.operationStatus;
        }
        break;

      case 'pageNumber':
        out.pageNumber = params.pageNumber;
        break;

      case 'pageSize':
        out.pageSize = params.pageSize;
        break;
    }
  });
  return out;
}
